<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="2" xs="12">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #requestDate="{item}">
            <td v-if="item.requestDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.requestDate) }}
            </td>
          </template>
          <template #phone-email="{item}">
            <td>
              {{ item.requestResidentPhone }}
              <span v-if="item.requestResidentPhone && item.requestResidentEmail"> - </span>
              {{ item.requestResidentEmail }}
            </td>
          </template>
          <template #requestFileUrl="{item}">
            <td v-if="item.requestFileUrl != null">
<!--              <a :href="item.requestFileUrl" target="_blank">Ấn vào để xem tệp</a>-->
              <span class="view-file" @click="viewFile(item.requestFileUrl)">Ấn vào để xem tệp</span>
            </td>
            <td v-else>

            </td>
          </template>
          <template #status="{item}">
            <td>
              <span class="badge badge-success" v-if="item.status == true">Đã trả lời</span>
              <span class="badge badge-warning" v-else>Chưa trả lời</span>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="item.status == false"
                      color="warning"
                      variant="outline"
                      v-c-tooltip.hover="'Trả lời'"
                      square
                      size="sm"
                      @click="responseFeedback('responseFeedback',item.id)">
                      <i class="fa fa-reply"></i>
                </CButton>
                <CButton v-if="item.status == true"
                      color="info"
                      variant="outline"
                      v-c-tooltip.hover="'Xem trả lời'"
                      square
                      size="sm"
                      @click="viewResponseFeedBack('viewResponseFeedBack',item)">
                      <i class="fa fa-eye"></i>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <ReponseResidentsFeedbackModal
        :actionTypeMapping="actionData.responseFeedback"
        ref="actionResponseFeedbackModel"
        >
    </ReponseResidentsFeedbackModal>

    <ViewReponseResidentsFeedbackModal
        :actionTypeMapping="actionData.viewResponseFeedBack"
        ref="actionViewResponseFeedbackModel">
    </ViewReponseResidentsFeedbackModal>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"
import ReponseResidentsFeedbackModal from './ReponseResidentsFeedbackModal.vue'
import ViewReponseResidentsFeedbackModal from './ViewReponseResidentsFeedbackModal.vue'
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "ResidentsFeedbackList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    ReponseResidentsFeedbackModal,
    ViewReponseResidentsFeedbackModal
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    var responseFeedback = new Map();
    responseFeedback.set("responseFeedback", {
      url: "/residents-feedback/responseFeedback",
      dataSubmit: function () {
        return {
          id: that.actionData.model.id
        };
      },
      successCallback: function () {
        that.showSuccessMsg({
          message: "Trả lời PAKN thành công"
        });
        that.loadDataMainTable();
      },
      isJsonContentType: true
    });
    return {
      loading:{value:false},
      actionData: {
        responseFeedback: responseFeedback,
        model: {
          selectedAll: false,
          id: null
        }
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề",
          label: 'Tiêu đề'
        },
        data: {
          name: "requestTitle",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "index", label: "STT"},
            {key: "requestTitle", label: "Tiêu đề"},
            {key: "requestField", label: "Lĩnh vực phản ánh"},
            {key: "requestDescription", label: "Nội dung"},
            {key: "requestFileUrl", label: "Tệp đính kèm"},
            {key: "requestResidentName", label: "Họ và tên"},
            {key: "requestDate", label: "Ngày phản ánh"},
            {key: "phone-email", label: "Thông tin liên hệ"},
            {key: "status", label: "Trạng thái"},
            {key: "action", label: "Thao tác"},
          ],
          slots: ["index", "requestDate", "phone-email", "requestFileUrl","action", "status"],
        },
        dataSource: {
          url: "/residents-feedback/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    responseFeedback: function (actionTypeKey, id) {
      this.$refs.actionResponseFeedbackModel.clearData();
      this.$refs.actionResponseFeedbackModel.setIdField(id);
      this.$refs.actionResponseFeedbackModel.setCurrAction(actionTypeKey);
    },
    viewResponseFeedBack: function(actionTypeKey, item) {
      this.$refs.actionViewResponseFeedbackModel.setCurrAction(actionTypeKey);
      this.$refs.actionViewResponseFeedbackModel.setItem(item);
    },
    async viewFile(url) {
      let that = this;
      this.loading.value = true;
      const data = await this.$helper.blobFileByUrl(url);
      setTimeout(() => {
        that.loading.value = false;
        window.open(data)
      }, 500)
      // window.open(this.$helper.viewFileByUrl(url))
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {

  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
